import {
  Box,
  BrandedProgressBar,
  Flex,
  Heading,
  keyframes,
} from '@edreamsodigeo/prisma-design-system';
import React from 'react';
import { useTranslation } from '@edreamsodigeo/frontend-core';

const TOTAL_ANIMATION_DURATION = 20;
const ANIMATION_DURATION = 5;
const animation = keyframes`
  0% {
    transform: translate3d(0, 50%, 0);
    opacity: 0;
  }
  3% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  22% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  25% {
    transform: translate3d(0, -50%, 0);
    opacity: 0;
  }
`;

export const AlternativeItineraryDoubleCardShoppingCartLoading = () => {
  const { t } = useTranslation();
  const textKeys = [
    'alternativeItinerary.loadingShoppingCart.text1',
    'alternativeItinerary.loadingShoppingCart.text2',
    'alternativeItinerary.loadingShoppingCart.text3',
    'alternativeItinerary.loadingShoppingCart.text4',
  ];

  return (
    <Flex flexDirection="column" alignItems="center" width="100%">
      <Box marginBottom="1x_small">
        <Heading type="3" weight="medium" textAlign="center">
          {t('alternativeItinerary.loadingShoppingCart.title')}
        </Heading>
      </Box>
      <Flex
        flexDirection="column"
        alignItems="center"
        marginBottom="base"
        minHeight="20px"
        width="100%"
        sx={{
          position: 'relative',
        }}
      >
        {textKeys.map((text, index) => (
          <Heading
            key={index}
            textAlign="center"
            type="5"
            weight="normal"
            sx={{
              animation: `${animation} ${TOTAL_ANIMATION_DURATION}s ${
                index * ANIMATION_DURATION
              }s ease-in-out infinite`,
              position: 'absolute',
              opacity: 0,
            }}
          >
            {t(text)}
          </Heading>
        ))}
      </Flex>
      <Box
        width="327px"
        sx={{
          backgroundColor: 'neutral.30',
          borderRadius: 'big',
          overflow: 'hidden',
          '& div': {
            backgroundColor: 'primary.50',
            borderRadius: 'big',
          },
        }}
      >
        <BrandedProgressBar />
      </Box>
    </Flex>
  );
};
